module.exports = __webpack_public_path__ + "7521c8879bef19477fbccef195248612.woff";